import React from "react";
import { Link } from "react-router-dom";

const AboutUs = ({ aboutRef }) => {
  return (
    <div ref={aboutRef}>
      <section id="about" className="about py-4 my-4 ">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row align-items-xl-center gy-5">
            <div className="col-xl-5 content">
              <h3>About Us</h3>
              <h2>
                Empowering Excellence in Conferences: Redefining Event
                Management with ConfChair
              </h2>
              <p className="text-justify">
                Welcome to ConfChair - where innovation meets seamless
                conference management! Welcome to CONFCHAIR, your premier
                platform for seamless conference management and research paper
                publication. At CONFCHAIR, we are dedicated to revolutionizing
                the way conferences are organized, papers are submitted, and
                decisions are made.
                <br />
                <br /> Our purpose is clear to provide authors with a dynamic
                and efficient platform for submitting their research papers and
                reviewers with the tools they need to evaluate submissions
                rigorously. We understand the importance of facilitating smooth
                interactions between authors, reviewers, and conference chairs
                to ensure timely and informed decisions. With CONFCHAIR,
                conference organizers can rely on a user-friendly interface to
                manage all aspects of their events, from scheduling to
                registration, with ease.
              </p>
              <Link to="/" className="read-more">
                <span>Connect with Us</span>
                <i className="bi bi-arrow-right"></i>
              </Link>
            </div>

            <div className="col-xl-7">
              <div className="row gy-4 icon-boxes">
                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="icon-box">
                    <i className="bi bi-command"></i>
                    <h3>Efficient Paper Submission</h3>
                    <p>
                      Streamlined submission process for authors, ensuring
                      effortless paper submission.
                    </p>
                  </div>
                </div>

                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="icon-box">
                    <i className="bi bi-command"></i>
                    <h3>Robust Review System</h3>
                    <p>
                      Comprehensive feedback tools for reviewers, facilitating
                      thorough paper evaluation.
                    </p>
                  </div>
                </div>

                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="icon-box">
                    <i className="bi bi-command"></i>
                    <h3>Seamless Conference Management</h3>
                    <p>
                      All-in-one platform for conference organizers, simplifying
                      scheduling and registration tasks.
                    </p>
                  </div>
                </div>

                <div
                  className="col-md-6"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <div className="icon-box">
                    <i className="bi bi-command"></i>
                    <h3>Flexibility and Interactivity</h3>
                    <p>
                      Dynamic tools for collaboration among conference
                      committees, enabling informed decision-making.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
